const unique = () => {
  return {
    parse: (sellerId: string | string[]) => {
      return Array.isArray(sellerId) ? sellerId[0] : sellerId;
    },
    stringify: (data): string => {
      return data?.toString() ?? "";
    },
  };
};

export default unique;
